import { ApiHelper, axiosInstance } from "../../utils/ApiHelper"
import { push, goBack } from "react-router-redux"
import { message } from "antd"

const getRemovedIds = (prevArr, nextArr) => {
  const prevIds = prevArr.map(r => r.id)
  const nextIds = nextArr.map(r => r.id)

  return prevIds.filter(id => {
    return !nextIds.includes(id)
  })
}

export function update(tokenId, rules_attributes, rule_actions_attributes) {
  // PUT #update { [{id: <rule_action.token_id>, :_destroy: true}]}

  return (dispatch, getState) => {
    const prev = getState().models.user.favorite_transactions.find(
      ({ id }) => id == tokenId
    )

    const removedRules = getRemovedIds(prev.rules, rules_attributes).map(
      id => ({
        id,
        _destroy: true
      })
    )

    const removedRuleActions = getRemovedIds(
      prev.rule_actions,
      rule_actions_attributes
    ).map(id => ({ id, _destroy: true }))

    const payload = {
      favorite_transaction: {
        rules_attributes: [...rules_attributes, ...removedRules],
        rule_actions_attributes: [
          ...rule_actions_attributes,
          ...removedRuleActions
        ]
      }
    }

    dispatch({
      type: "UPDATE_FAVE_TXN_REQUEST",
      payload,
      tokenId
    })
    return ApiHelper.updateFavoriteTransaction(tokenId, payload).then(
      ({ data }) => {
        dispatch({
          type: "UPDATE_FAVE_TXN_SUCCESS",
          data
        })
        message.success("Sucessfully updated rule", 3)

        dispatch(push(`/account/favorite-transactions`))
      },
      ({ data: { errors }, status }) => {
        dispatch({
          type: "CREATE_FAVE_TXN_FAIL",
          errors,
          status
        })
        message.error(errors, 3)
      }
    )
  }
}

export function create(rules_attributes, rule_actions_attributes) {
  return dispatch => {
    dispatch({
      type: "CREATE_FAVE_TXN_REQUEST",
      rules_attributes,
      rule_actions_attributes
    })
    return ApiHelper.createFavoriteTransaction(
      rules_attributes,
      rule_actions_attributes
    ).then(
      ({ data }) => {
        dispatch({
          type: "CREATE_FAVE_TXN_SUCCESS",
          data
        })
        dispatch(push(`/account/favorite-transactions`))
        message.success("Sucessfully created rule", 3)
      },
      ({ data: { errors }, status }) => {
        dispatch({
          type: "CREATE_FAVE_TXN_FAIL",
          errors,
          status
        })
        message.error(errors, 3)
      }
    )
  }
}

export function destroy(tokenId) {
  return dispatch => {
    dispatch({
      type: "DELETE_FAVE_TXN_REQUEST",
      tokenId
    })
    return ApiHelper.destroyFavoriteTransaction(tokenId).then(({ data }) => {
      dispatch({
        type: "DELETE_FAVE_TXN_SUCCESS",
        payload: data,
        tokenId
      })
      message.success("Sucessfully deleted rule", 3)

      dispatch(push(`/account/favorite-transactions`))
    })
  }
}

export function show(tokenId) {
  return dispatch => {
    dispatch({
      type: "SHOW_FAVE_TXN_REQUEST",
      tokenId
    })
    return ApiHelper.showFavoriteTransaction(tokenId).then(({ data }) => {
      dispatch({
        type: "SHOW_FAVE_TXN_SUCCESS",
        payload: data
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/account/favorite-transactions/actions.js